import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import "./change-owner.scss";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
function ChangeOwnerModal(props: any) {
  const [userType] = useState([
    { value: "executor", label: "Executor" },
    { value: "evaluator", label: "Evaluator" },
    { value: "function_head", label: "Function Head" },
  ]);
  const {
    request,
    setRequest,
    handleModal,
    isOpen,
    userList,
    userLoading,
    submitUserLoading,
    getUsersList,
    handleChangeSelect,
    handleSubmitChangeUser,
    changeOwnerType,
    conflictList,
  } = props;

  const filteredUserTypes =
    changeOwnerType === "License"
      ? userType.filter(
          (item) => item.value === "executor" || item.value === "evaluator",
        )
      : userType;
  return (
    <div>
      <Modal isOpen={isOpen} className="add-comments-popup-config" centered>
        {conflictList?.length ? (
          <div className="dropdown-menu-change_owner">
            <table className="table-section w-100 table ">
              <tr>
                <th>Task ID</th>
                <th>Existing Role</th>
                <th>Requested Role</th>
              </tr>
              {conflictList?.map((item: any) => {
                return (
                  <tr>
                    <td>
                      <p
                        style={{
                          fontSize: "14px",
                          marginTop: "0px",
                        }}
                      >
                        {item.task_display_id}
                      </p>
                    </td>
                    <td>
                      <p
                        style={{
                          fontSize: "14px",
                          marginTop: "0px",
                        }}
                      >
                        {item?.existing_role?.map(
                          (itm: string) => itm.toUpperCase() + ",",
                        )}
                      </p>
                    </td>
                    <td>
                      <p
                        style={{
                          fontSize: "14px",
                          marginTop: "0px",
                        }}
                      >
                        {item.requested_role.toUpperCase()}
                      </p>
                    </td>
                  </tr>
                );
              })}
            </table>
            <div className="d-flex justify-content-end">
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--primary"
                onClick={handleModal}
              >
                Cancel
              </button>
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                onClick={handleSubmitChangeUser}
                disabled={submitUserLoading ? true : false}
              >
                {submitUserLoading ? "Please wait..." : "Confirm"}
              </button>
            </div>
          </div>
        ) : (
          <div className="dropdown-menu-change_owner">
            <p className="header-text">Bulk Update Tasks</p>
            <p className="desc-text">
              Choose a field from dropdown and update with new information
            </p>
            <div className="modal-grid grid-body">
              <div className="modal-input-grid-item">
                <label htmlFor="state">Select User Type *</label>
                <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Choose User Type"
                  name="state_id"
                  id="state_id"
                  options={filteredUserTypes}
                  value={filteredUserTypes.filter(
                    (item: any) =>
                      getValue(item, `value`, "") ===
                      getValue(request, `type`, ""),
                  )}
                  onChange={(e: any) =>
                    setRequest({
                      ...request,
                      type: getValue(e, `value`, ""),
                    })
                  }
                  class={"model-grid__form-control"}
                  isClear
                />
              </div>
              <div className="modal-input-grid-item">
                <label htmlFor="law">Users *</label>
                <SearchableDropdownSelect
                  placeholder={"Select User"}
                  options={userList}
                  searchLoading={userLoading}
                  handleChange={(val: any) => getUsersList(val, "")}
                  handleClick={(e: any) => handleChangeSelect(e, "user")}
                  value={
                    getValue(userList, `length`, 0) > 0
                      ? userList.filter(
                          (item: object) =>
                            getValue(item, `id`, "") ===
                            getValue(request, `id`, ""),
                        )[0]
                      : ""
                  }
                  label="label"
                  id="id"
                  name="Executor"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--primary"
                onClick={handleModal}
              >
                Cancel
              </button>
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                onClick={handleSubmitChangeUser}
                disabled={submitUserLoading ? true : false}
              >
                {submitUserLoading ? "Please wait..." : "Submit"}
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default ChangeOwnerModal;
